const listaDeHistoricoStar21 = (state) => {
    return state.items;
}

const loadingFichaTecnica = (state) => {
    return state.carregando
}

const historicoStar21Selecionado = (state) => {
    return state.selecionado
}

const dadosFichaTecnica = (state) => {
    return state.fichaTecnica
}

const dadosFichaTecnicaTarefa = (state) => {
    return state.fichaTecnicaTarefa
}

const fichaTecnicaHttpStatusCode = (state) => {
    return state.httpStatusCode
}

const dadosHistoricoFichaTecnica = (state) => {
    return state.historicoFichaTecnica
}

const historicoTicket = (state) => {
    return state.historicoTicket;
}

const listaDeOpcoesTratativasTarefas = (state) => {
    return state.opcoesTratativasTarefas;
}

const dadosAdocao = (state) => {
    return state.dadosAdocao;
}

const carregandoPcoTarefas = (state) => {
    return state.carregandoPcoTarefas;
}

const listaDeLogsPcoTarefas = (state) => {
    return state.tarefas;
}

const listaTratativas = (state) => {
    return state.listaTratativas || [];
}

export {
    listaDeHistoricoStar21,
    loadingFichaTecnica,
    historicoStar21Selecionado,
    dadosFichaTecnica,
    dadosFichaTecnicaTarefa,
    fichaTecnicaHttpStatusCode,
    dadosHistoricoFichaTecnica,
    historicoTicket,
    listaDeOpcoesTratativasTarefas,
    dadosAdocao,
    carregandoPcoTarefas,
    listaDeLogsPcoTarefas,
    listaTratativas
}